import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../lib/react-query';
import { fetchApi } from '../lib/fetchApi';
import { UserSelectDto } from '../features/admin/users/types';

export const getUsersSelect = async (): Promise<UserSelectDto[]> => {
  const response = await fetchApi.get(`/users/select`) as UserSelectDto[];
  return response;
}

type QueryFnType = typeof getUsersSelect;

type UseSurveyOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useUsersSelect = ({  config = {} }: UseSurveyOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['usersSelect'],
        queryFn: () => getUsersSelect(), // el "!" es seguro porque solo se ejecuta si enabled es true
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};